import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2030. 固定資産削除
 * [DELETE] /workspaces/:identifier/fixed_assets/:id
 */
type Props = {
  identifier: string;
  id: number;
};

const destroyFixedAsset = (props: Props) => {
  return axios.delete(`/api/workspaces/${props.identifier}/fixed_assets/${props.id}`);
};

export const useDestroyFixedAsset = () => {
  return useMutation({
    mutationFn: destroyFixedAsset,
  });
};
